
import React, { useState, useRef,useEffect } from "react";
import {Link} from 'react-router-dom';
import {Navigate} from 'react-router-dom';
import Container from 'react-bootstrap/Container';
import Navbar from 'react-bootstrap/Navbar';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Form from 'react-bootstrap/Form';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import SimpleReactValidator from 'simple-react-validator';
import logo from '../images/logo.png';
import lback from '../images/lback1.png';
import lback2 from '../images/lback2.png';
import '../Assets/css/custom.css';
import styles from "../Assets/styles";
import axios from 'axios';
import FadeLoader from "react-spinners/HashLoader";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEye } from "@fortawesome/free-solid-svg-icons";
import { faLock} from "@fortawesome/free-solid-svg-icons";
import { faUser} from "@fortawesome/free-solid-svg-icons";
import ContainerImage from '../images/lback3.png';
import { useNavigate } from "react-router-dom";
import 'animate.css';

import banner01 from '../images/info/1.jpg';
import banner02 from '../images/info/2.jpg';
import banner03 from '../images/info/3.jpg';

import authService from './Authservice';
const autFile = new authService('http://localhost:3000/')
var NetIssue2 = <div/>;
var api = require('../Common/Config');
var USER_ID = 'secured/user/getUserData?userId=';

const eye = <FontAwesomeIcon icon={faEye} />;
const lock = <FontAwesomeIcon icon={faLock} />;
const users = <FontAwesomeIcon icon={faUser} />;

function Login() {
    const[UserName, setuserName] = useState('');
    const[PassWord, setPassWord] = useState('');
    const[showProgress,setProgress] = useState(false);
    const[isLogin,setLogin] = useState(false);
    const[NetIssue,setNetIssue] = useState("");
    const[errorValues,setErrorValues] = useState({});
    const[ ShowPassword,setShowPassword] = useState(false);
    const[ ErrorMsg,setErrorMsg] = useState(false);
    const[ ImageChange,setImageChange] = useState(false);
    const navigate = useNavigate();
    const inputUN = useRef(null);

    let name ="";
    let pass = "";      
    let submit="";
    var errCount = <div/>;  

    if (!errorValues.success && errorValues.badCredentials){
      
     errCount =  <p className="error-text">
                    Invalid username or password
                  </p>;
    }
    if (!errorValues.success && errorValues.Unauthorized){
     
      errCount = <p className="error-text">
                      User is locked or Inactive
                 </p>;
    }
    if (!errorValues.success && errorValues.unknowError){
      
      errCount = <p className="error-text">
                      Something went wrong<br/>
                 </p>;          
    }
    
    const ResponseLoadingModal = () =>{
        return(
            <Modal
            size="lg"
            centered 
            className="ui-block" show={showProgress}>          
                  <FadeLoader
                  height={25}
                  width={5}
                  radius={2}
                  margin={2}
                  color={"#197b55"}
                  size={"80px"} this also works
                  loading={showProgress}
                />
           
           </Modal>
         )
      }

    const  UserDetails = () =>{
        var getData = sessionStorage.getItem("tokenData");
        var state = JSON.parse(getData);
  
        return(  axios ( {         
              url: api.HOST+USER_ID+UserName,          
              method: "GET",
              headers: {
                'Authorization' : 'bearer '+ state.accesstoken,
                'Content-Type': 'application/json',
              }
            }) .then((result) => {
  
              if(result.data.status==="error"){
               
                var NVU = {
                  checkValidUser:'NotValid',
                }
                var UValue = JSON.stringify(NVU);
                sessionStorage.setItem('CheckUserValid', UValue );
                
                setLogin(false);
                setProgress(false);
                setErrorMsg ("Service Temporarily Unavailable");
                return ;
                }else{
  
                  var User = {
                    id:result.data.id,
                    IdOfUser:result.data.customerId,
                    preferredNIC:result.data.preferredNIC,
                    title:result.data.title,
                    UserFirstname:result.data.firstName,
                    UserLastname:result.data.lastName,
                    previousLogin:result.data.previousLogin,
                    companyName:result.data.companyName,
                    customerIdType:result.data.customerIdType,
                    customerId:result.data.customerId,
                    email:result.data.email,
                    mobile:result.data.mobile,
                    Addressline1 : result.data.permenentAddress.addressLine1,
                    Addressline2 : result.data.permenentAddress.addressLine2,
                    Addressline3 : result.data.permenentAddress.locality,
                }
  
                var UserValue = JSON.stringify(User);
                sessionStorage.setItem('NIC', UserValue );
  
                var User = {
                  customerName : result.title+" "+result.firstName+" "+result.lastName,
                  customerNo : result.customerNo,
                }
                var value = JSON.stringify(User);
                sessionStorage.setItem('Customer', value );
                navigate('/Home')
                setProgress(false);
                setErrorMsg ();               
                return ;
              }
            }).catch((error)=> {
              console.log(error);
          })
          );
      }

   const onLoginPressed = () =>{
        setProgress(true);
        if (navigator.onLine) {
          console.log('online');
        } else {
          console.log('Off Line');
          NetIssue2= <p className="error-text">
                      No internet connection
                     </p>    
        } 
          var User = {
            id : UserName.trim().toLowerCase(),
          }
          var value = JSON.stringify(User);
          sessionStorage.setItem('userId', value);
          //this.NewLoginCall();  
            autFile.login({
              username: UserName,
              password: PassWord
            },(results)=>{
              setErrorValues(Object.assign({
               
               badCredentials: results == 400,
               Unauthorized: results == 401,              
               unknowError: results != 400 && results!==401,
               showProgress: results.success?true:false, 
                  //isLogin:true,
              },results));        
                  if(results.success){
                      UserDetails();                      
                    }else{    
                      setProgress(false);                        
                      setNetIssue("Service Temporarily Unavailable")                                   
                    }
                });
              }
        const hsetShowPassword = () =>{
            setShowPassword(true)
            setTimeout(() => {
                setShowPassword(false)
              }, 900);
        }

        const keyUpFunct = (type,e) =>{
          if(e.keyCode===13){
          switch(type){
            case "name":
              pass.focus();
              break;
            case "pass":
              submit.focus();
              break;
            case "submit":
              name.focus();
            break;
              default:
              name.focus();
            }
          }        
        }
         
        const handlePressEnter = (e) => {
          if(e.key == 'Enter'){
            onLoginPressed();
          }
        }
            return(    
            <Container fluid className="body-register">     
              <Container>
              {ResponseLoadingModal()}
                <Row>
                  <Col lg={4}>
                    <div className="login-area block-top bottoms ">
                      <img className='logo' alt="Senfin" src={logo} />
                      <div>
                        <h3>SENFIN ONLINE PORTAL </h3>   
                        <p className='small-font-log'>MAKE YOUR DIGITAL TRANSACTIONS THE SIMPLE WAY</p>                     
                      </div>                        
                    </div>
                  </Col>               
                </Row>
                <Row className="flex-row-center mt-4">
                <Col lg={5} sm={12}>
                  <div className="main-wrap2 animate__animated animate__fadeIn animate__faster">                
                    <div  className="login-box bottoms">
                      <div className="login-area bottoms ">
                          <div className="d-flex align-items-start flex-column">
                            <h3>WELCOME</h3> 
                            <p className='small-font-log mt-1' style={{color:'#000000c2'}}>
                              Experience unlimited banking that combines quality,
                              usability, safety and easy-of-use to manage
                              your money anywhere, anytime.
                            </p>                       
                          </div>                        
                      </div>
                      <Form style={{width:'100%'}} onSubmit={e => e.preventDefault()}>
                          <Form.Group className="s-bottoms" > 
                          <div className="input-group mb-3">
                              <div className="input-group-prepend">
                                <span className="input-group-text l-img" id="basic-addon1">{users}</span>
                              </div>                        
                              <input 
                                ref={(e)=>{name=e}}
                                autoFocus
                                onKeyUp={(e)=>keyUpFunct("name",e)}
                                className="l-input" type="text" placeholder="USERNAME"
                                onChange={(e) => setuserName(e.target.value)}
                              />                        
                          </div>
                          </Form.Group>
                          <Form.Group className="bottoms" > 
                          <div className="input-group mb-3">
                              <div className="input-group-prepend">
                                <span className="input-group-text l-img" id="basic-addon1">{lock}</span>
                              </div>                 
                              <input 
                              ref={(e)=>{pass=e}}
                              onKeyUp={(e)=>keyUpFunct("pass",e)}
                              maxLength={8} className="l-input" type={ShowPassword?"text":"password"} placeholder="PASSWORD" onChange={(e) => setPassWord(e.target.value)} onKeyDown={handlePressEnter}/>
                              <ieshow className="ieshow2" onClick={()=>{hsetShowPassword()}}>{eye}</ieshow>
                            </div>
                          </Form.Group> 
                          {errCount}
                          
                          <p className="error-text"> {ErrorMsg}</p>                     
                      </Form>
                      <div style={{width:'90%'}}>
                          <Row className="align-items-center s-bottoms">
                            <Col lg={7} xs={7} className="col-md-6">
                              <Link to="/ForgotPassword">
                                  <a className='small-font2 h-link forgot-password' href="">Forgot Password ?</a> 
                              </Link>
                            </Col>
                            <Col lg={5} xs={5} className="d-flex justify-content-end align-items-center col-md-6">
                            <Button 
                            ref={(e)=>{submit=e}} 
                            variant="primary" size="sm"                       
                            onKeyUp={(e)=>keyUpFunct("submit",e)}
                            disabled={showProgress}  onClick={()=>onLoginPressed()} className="btn-login s-bottoms"> 
                                LOGIN
                            </Button>
                            </Col> 
                          </Row>
                          <p className="hr-line">or</p>
                          <Row>
                            <Col lg={12} xs={12} className="col-md-6 ">
                                <Link to="/UserRegister" className="small-font2 h-link s-top2 underline">Create a new user account</Link>
                            </Col>
                          </Row>           
                      </div>   
                    </div>                    
                  </div>
                </Col>
                </Row>
                <Row className="mt-5">
                    <Col md={12} lg={12}
                      style={{display:'flex', flexDirection:'row', justifyContent:'center'}}
                    >
                      <img
                        style={{width:'20%', height:'100%', marginRight:'50px'}}
                        src={banner01}
                      />
                      <img
                        style={{width:'20%', height:'100%'}}
                        src={banner02}
                      />
                      <img
                        style={{width:'20%', height:'100%', marginLeft:'50px'}}
                        src={banner03}
                      />
                    </Col>
                </Row>
              </Container>
            </Container>    
            )
    
}
export default Login;